import { CONSULTATION } from "@/shared/constants/routes";

import { ConsultationRoutes } from "@/features/consultation/presentation/routes/ConsultationRoutes";

import { RouteConfig } from "../routes";

export const routes: RouteConfig[] = [
  { path: CONSULTATION, element: <ConsultationRoutes />, isPrivate: true }
];
